import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type {
  FriendsOverview,
  LeaderboardEntry,
  LeaderboardScope,
  PrivacyLevelValue,
  PrivacySettings,
  ReportPayload,
  UserSearchResult,
} from '../types'

interface FriendshipMutationResult {
  id: string
  status: string
}

export const socialApi = {
  fetchFriends: () => apiClient.get<ApiResponse<FriendsOverview>>('/friends'),

  searchUsers: (username: string) =>
    apiClient.get<ApiResponse<UserSearchResult[]>>('/users/search', { params: { username } }),

  sendRequest: (userId: string) =>
    apiClient.post<ApiResponse<FriendshipMutationResult>>('/friends', { user_id: userId }),

  acceptRequest: (id: string) =>
    apiClient.patch<ApiResponse<FriendshipMutationResult>>(`/friends/${id}/accept`),

  declineRequest: (id: string) =>
    apiClient.patch<ApiResponse<FriendshipMutationResult>>(`/friends/${id}/decline`),

  removeFriend: (userId: string) =>
    apiClient.delete<ApiResponse<{ removed: boolean }>>(`/friends/${userId}`),

  blockUser: (userId: string) =>
    apiClient.post<ApiResponse<{ blocked: boolean }>>('/blocks', { user_id: userId }),

  unblockUser: (userId: string) =>
    apiClient.delete<ApiResponse<{ blocked: boolean }>>(`/blocks/${userId}`),

  reportUser: (payload: ReportPayload) =>
    apiClient.post<ApiResponse<{ reported: boolean }>>('/reports', payload),

  fetchPrivacy: () => apiClient.get<ApiResponse<PrivacySettings>>('/me/privacy'),

  updatePrivacy: (level: PrivacyLevelValue) =>
    apiClient.put<ApiResponse<{ level: PrivacyLevelValue }>>('/me/privacy', { level }),

  fetchLeaderboard: (scope: LeaderboardScope) =>
    apiClient.get<ApiResponse<LeaderboardEntry[]>>('/leaderboard', { params: { scope } }),
}
